import React from 'react'
import { Dispatch } from 'redux'
import { Formik } from 'formik'
import { IGroupDetailed } from '../../types/group'
import { updateGroup } from '../../actions/group'
import { push } from '../../actions/router'
import {
  transformRolesInputToState,
  transformRolesStateToInput,
} from '../../services/groups'
import { groupValidationSchema } from '../CreateGroupForm/validation'
import { NavigationGuard } from '../../components'
import { GroupForm } from '../GroupForm'

export interface IUpdateGroupForm {
  group: IGroupDetailed
  editable: boolean
  dispatch: Dispatch
}

export const UpdateGroupForm = ({
  group,
  editable,
  dispatch,
}: IUpdateGroupForm) => (
  <>
    <Formik
      key={group.modified}
      initialValues={transformRolesStateToInput(group)}
      onSubmit={(values) => {
        dispatch(updateGroup(transformRolesInputToState(values)))
      }}
      render={(formikProps) => (
        <>
          <GroupForm
            formikProps={formikProps}
            nameDisabled
            cancelAction={() => {
              formikProps.resetForm()
              dispatch(push('/settings/groups?tab=groups'))
            }}
            submitText="Save"
            editable={editable}
          />
          <NavigationGuard isBlocking={formikProps.dirty} />
        </>
      )}
      validationSchema={groupValidationSchema}
    />
  </>
)
